import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { FREE_MEMBERSHIP_TYPES } from 'types'
import { selectors as memberSelectors } from 'member-reducer'
import ProductPricesUnavailable from './ProductPricesUnavailable'

const propTypes = {
  children: PropTypes.node.isRequired,
  hasPaidSelection: PropTypes.bool,
  selectedPrice: PropTypes.number,
}

// Blocks the selection step when a paid type's price didn't load, so the member
// never sees a broken price or moves toward a $0 charge.
function ProductPricesGuard({
  children,
  hasPaidSelection = false,
  selectedPrice = null,
}) {
  if (hasPaidSelection && selectedPrice == null)
    return <ProductPricesUnavailable />

  return children
}

ProductPricesGuard.propTypes = propTypes

function mapStateToProps(state) {
  const selectedMembershipType = memberSelectors.selectedMembershipType(state)

  return {
    // Any non-free selection must resolve a price (covers any future card too).
    hasPaidSelection:
      selectedMembershipType != null &&
      !FREE_MEMBERSHIP_TYPES.includes(selectedMembershipType),
    selectedPrice: memberSelectors.membershipPrices(state)[selectedMembershipType],
  }
}

export default connect(mapStateToProps)(ProductPricesGuard)
